import '../App.css';
import { Link } from 'react-router-dom';


function Pb() {

  return (
      <div className='container' style={{background:'white'}}>
        <div className='headbanner box'>
            <div className='box bannerbuttons'>
                <div className='box button headbannerbutton'>
                    <Link to="brbtx">BRbtx</Link>
                </div>
                <div className='box button headbannerbutton'>
                    <Link to="pb">PB</Link>
                </div>
                <div className='box button headbannerbutton'>
                    <Link to="wbw">WBW</Link>
                </div>
            </div>
            <div className='box text'>
                Teejeigh LLC
            </div>
        </div>
      </div>
  );
}

export default Pb;